module.exports = __webpack_public_path__ + "img/37.2c2a514f.jpg";